import { faEnvelope, faPhoneAlt, faToggleOn, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const AllGuests = ({guestList}) => {
    return (
        <div className="guest-list-comp">
            <div className="guest-card">
                <h6>Name</h6>
                <h6>Email</h6>
                <h6>Phone</h6>
                <h6>Status</h6>
            </div>
            {guestList.length > 0 && 
            guestList.map((guest) => (
                <div className="guest-card" key={guest.id}>
                    <h6>{guest.userName && guest.userName}</h6>
                    <h6>{guest.emailAddress && guest.emailAddress}</h6>
                    <h6>{guest.mobileNumber && guest.mobileNumber}</h6>
                    {guest.RSVP === "accepted" ?
                    <h6>Accepted</h6>
                    :
                    <h6>{guest.isInvited ? 'Pending' : 'Not Invited'}</h6>}
                </div>
            ))
            }

            {guestList.length > 0 && 
            guestList.map((guest) => (
            <div className="guest-card-mobile"  key={guest.id}>
                <h6>
                    <FontAwesomeIcon icon={faUser} />Name: {guest.userName && guest.userName}
                    </h6>
                <h6>
                    <FontAwesomeIcon icon={faEnvelope} />E-mail: {guest.emailAddress && guest.emailAddress}
                </h6>
                <h6>
                    <FontAwesomeIcon icon={faPhoneAlt} />Mobile: {guest.mobileNumber && guest.mobileNumber}
                </h6>
                <h6>
                    <FontAwesomeIcon icon={faToggleOn} />Status: {guest.RSVP === "accepted" ? 'Accepted' : guest.isInvited ? 'Pending' : 'Not Invited'}
                </h6>
            </div>))}

        </div>
    );
};

export default AllGuests;
